module.exports = __webpack_public_path__ + "static/years_watermark-aa6c64c5cbce5f79d7c9b735d8a25162.png";